<template>
  <div>
    <div ref="pageTopAnchor" style="height:80px;margin-top:-80px;"></div>
    <div class="ceiling">
      <home-top></home-top>
      <top-search :showHot="true" type="home"></top-search>
      <navicat :current="4" background="#fff"></navicat>
    </div>
    <!-- 头部占位 -->
    <!-- <div class="h-top"></div> -->
    <!-- banner图 -->
    <div class="bannre-box mini-width">
      <el-carousel height="400px">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <img class="banner-image" :src="item.image"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 身体内容 -->
    <div class="content w-1400">
      <div class="content-title">
        <div class="content-big-word">化工资讯</div>
        <div class="content-small-word">News</div>
      </div>
      <div class="content-body">
        <div class="content-body-inner">
          <div class="content-list-left">
            <new-item
                v-for="(item, index) in newsList"
                :key="index"
                :news="item"
            ></new-item>
          </div>
          <div class="content-list-right">
            <div class="news-box-item">
              <news-box type="news"></news-box>
            </div>
            <div class="news-box-item">
              <news-box type="qi"></news-box>
            </div>
          </div>
        </div>
        <div class="paging-box">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import homeTop from "../../components/public/home-top.vue";
import topSearch from "../../components/public/top-search.vue";
import navicat from "../../components/navicat/navicat.vue";
import homeFooter from "../../components/public/home-footer.vue";
import newItem from "../../components/goods/new-item.vue";
import newsBox from "../../components/goods/news-box.vue";
import {getNewsList} from "@/api/modules/home";
import {getSwiperList} from "@/api/modules/common";

export default {
  name: "ruitian-news",
  components: {
    homeTop,
    navicat,
    homeFooter,
    newItem,
    newsBox,
    topSearch
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      newsList: [],
      bannerList: [],
    };
  },
  created() {
    this.getNews();
    this.getBannert();
  },
  methods: {
    getBannert() {
      getSwiperList(2).then((res) => {
        this.bannerList = res.data.data;
      });
    },
    getNews() {
      getNewsList({page: this.pageNum, limit: this.pageSize}).then((res) => {
        this.newsList = res.data.data.data;
        this.total = res.data.data.total;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getNews();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getNews();
      this.$refs.pageTopAnchor?.scrollIntoView({behavior: 'auto', block: 'start'})
    },
  },
};
</script>
<style lang="scss" scoped>
.bannre-box {
  width: 100%;
  height: 400px;

  .banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.h-top {
  // height: 157px;
  //height: 80px;
  height: 265px;
}

.content {
  padding-top: 40px;

  .content-title {
    margin-bottom: 20px;

    .content-big-word {
      font-weight: bold;
      font-size: 24px;
      color: #00112b;
    }

    .content-small-word {
      display: inline-block;
      font-weight: 400;
      font-size: 24px;
      color: #00112b;
      padding: 10px 47px 10px 0;
      border-bottom: 1px solid #707070;
    }
  }

  .content-body {
    .paging-box {
      text-align: center;
      padding: 86px 0 104px;
    }

    .content-body-inner {
      display: flex;
      justify-content: space-between;

      .content-list-left {
        width: 930px;
      }

      .content-list-right {
        width: 430px;

        .news-box-item {
          margin-bottom: 40px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
